import script from "./chat.vue?vue&type=script&setup=true&lang=js"
export * from "./chat.vue?vue&type=script&setup=true&lang=js"

import "@/style/chat/chat.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__